import React, { Dispatch, useEffect, useState } from 'react';

import styles from './ProductPage.module.scss';
import { getTopSellers } from '../../api';
import { Button } from '../../components/Button';
import { TopSellersListItem } from '../../components/CustomersList/TopSellersListItem';
import { SnackbarProps } from '../../components/Snackbar';
import { CurrentUser } from '../../types';
import useCheckMobileScreen from '../../utils/services';
import cx from 'classnames';

export type SimilarBrandsProps = {
  title?: string;
  sellers: any;
  leftAligned?: boolean;
  ambassadors?: number;
  currentUser?: CurrentUser;
  setSnackbarMessage: Dispatch<SnackbarProps | null>;
  withBorder?: boolean
};

export const TopSellers = ({ title = 'Top Sellers', sellers, ambassadors, leftAligned, currentUser, setSnackbarMessage, withBorder=true }: SimilarBrandsProps) => {
  const isMobile = useCheckMobileScreen()

  const [data, setData] = useState(sellers.data);
  const [total, setTotal] = useState(sellers.meta.total);
  const [limit, setLimit] = useState(sellers.meta.per_page || 6);
  const [pageLoaded, setPageLoaded] = useState(1);

  const allPagesLoaded = pageLoaded * limit >= total;

  const loadMore = async () => {
    const response = await getTopSellers({ limit, page: pageLoaded + 1, ambassadors });

    setData(prevState => [...prevState, ...response.data]);
    setPageLoaded(prevState => prevState + 1);
  }

  return (
    <div className={cx(styles.related, {[styles.bordered]: withBorder})}>
      <h2 className={cx(styles.relatedTitle, {[styles.titleLeft]: leftAligned})}>{title}</h2>

      {isMobile ? (
        <SellersList
          data={data}
          currentUser={currentUser}
          setSnackbarMessage={setSnackbarMessage}
        />
      ) : (
        <div className={styles.sellersListsRow}>
          <SellersList
            data={data.filter((a, i) => i%2===0)}
            currentUser={currentUser}
            setSnackbarMessage={setSnackbarMessage}
          />

          <SellersList
            data={data.filter((a, i) => i%2===1)}
            currentUser={currentUser}
            setSnackbarMessage={setSnackbarMessage}
          />
        </div>
      )}

      <div className={styles.likeGearLoadMore}>
        {!allPagesLoaded && (
          <div>
            <Button
              caption="SHOW MORE"
              action={loadMore}
              buttonType="blue"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const SellersList = ({data, currentUser, setSnackbarMessage}) => {
  const [openedIndex, setOpenedIndex] = useState<number>(0)

  return (
    <div className={styles.toSellersWrapper}>
      {data.map((user, index) => (
        <TopSellersListItem
          key={user.username}
          isOpened={index===openedIndex}
          onOpen={() => setOpenedIndex(index)}
          user={user}
          currentUser={currentUser}
          setSnackbarMessage={setSnackbarMessage}
        />
      ))}
    </div>
  )
}
